export default "__VITE_ASSET__4ff994f0__"